import EntertainmentModel    from '@models/shop/EntertainmentModel';
import ParticipationModel    from '@models/website/ParticipationModel';
import ProductSetStatusModel from '@models/shop/ProductSetStatusModel';
import ProductSetTypeModel   from '@models/shop/ProductSetTypeModel';
import doc                   from '@widesk-core/decorators/doc';
import model                 from '@widesk-core/decorators/model';
import ShopServiceModel      from '@/models/ShopServiceModel';
import TimestampAble         from '@widesk-core/models/traits/TimestampAble';
import Blamable              from '@/models/traits/Blamable';
import Translatable          from '@widesk-core/models/traits/Translatable';
import WithEntertainmentPath from '@/models/mixins/withEntetainmentPath';
import { RenderNameProps }   from '@widesk-ui/mixins/ApiModelRenderName';
import { getLocale }         from '@widesk-core/locale';

@model.urnResource('product_set')
@doc.path('/product_sets/{?id}')
export default class ProductSetModel extends Blamable(TimestampAble(Translatable(WithEntertainmentPath(ShopServiceModel), {
	'title': true,
	'description': true,
}))) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'entertainment': id;
		'entertainment.entertainmentUrn': Urn;
		'exists[linkUrn]': '0' | '1';
		'exists[productProductSets]': '0' | '1';
		'linkUrn': Urn;
		'productProductSets.product': id;
		'productProductSets.product.productStatus': id;
		'productProductSets.product.productStatus.reference': Shop_ProductStatusReference;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.end[after]': string;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.end[before]': string;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.end[strictly_after]': string;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.end[strictly_before]': string;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.start[after]': string;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.start[before]': string;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.start[strictly_after]': string;
		'productProductSets.product.productVariants.productVariantSchedules.schedule.start[strictly_before]': string;
		'productSetStatus': id;
		'productSetStatus.reference': Shop_ProductSetStatusReference;
		'productSetType': id;
		'productSetType.reference': Shop_ProductSetTypeReference;
		'slug': id;
		'translations.title': string;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'position': string;
		'translations.title': string;
		'updatedAt': string;
	};

	@doc.model(EntertainmentModel) declare entertainment: EntertainmentModel;
	@doc.modelUrn(ParticipationModel) declare link: ParticipationModel;
	@doc.number declare position: number;
	@doc.model(ProductSetStatusModel) declare productSetStatus: ProductSetStatusModel;
	@doc.model(ProductSetTypeModel) declare productSetType: ProductSetTypeModel;
	@doc.string declare slug: string;

	// URL du produit invité sur la billetterie (undefined tant que la campagne n'est pas chargée)
	public getShopUrl(lang: LanguageKey = getLocale()): string | undefined {
		const shopUrl = window.APP_CONFIG.services.find(s => s.id === 'shop')?.url;
		const entertainmentSlug = this.entertainment.slug;

		if (!shopUrl || !entertainmentSlug || !this.slug) return;

		// Seule l'origine est conservée (l'url du service peut pointer vers l'admin, ex : https://ticket.japan-expo.com/admin)
		return `${new URL(shopUrl).origin}/${lang}/evenements/${entertainmentSlug}/invites/${this.slug}`;
	}

		public renderName(props?: RenderNameProps<this> & ProductSetNameProps) {
		return super.renderName(props);
	}
}
